import React, { useState } from 'react';
import { Search, Users, Clock, MoveRight } from 'lucide-react';
// Course images
import frontendimg from "../Assets/frontend-development.png";
import backendimg from "../Assets/backend-development.png"
import fullstackimg from "../Assets/full-stack-development.png"
import appdevimg from "../Assets/app-development.png"
import pythonimg from "../Assets/python-programming.png"
import javaimg from "../Assets/java-programming.png"
import cplusimg from "../Assets/cpp-programming.png"
import cimage from '../Assets/c-programming.png'
import devopsimg from "../Assets/devops.png"
import aiengimg from "../Assets/artificial-intelligence.png"
import machineimg from "../Assets/machine-learning.png"
import datasceinceimg from "../Assets/data-science.png"
import dataanalyticsimage from "../Assets/data-analytics.png"
import bioinfoimg from "../Assets/bioinformatics.png"
import powerbiimg from "../Assets/power-bi.png"
import graphicdesimg from '../Assets/graphic-design.png'
import uxuiimg from "../Assets/ui-ux-design.png"
import wordpressimg from "../Assets/wordpress-development.png"
import digimarketimg from "../Assets/digital-marketing.png"
import contentwriterimg from "../Assets/content-writing.png"
import humanresourceinmg from "../Assets/human-resource.png"
import stockimage from "../Assets/stock-market.png"
import finaceInvimg from "../Assets/finance-investment.png"
import cyberimg from "../Assets/cyber-security.png"
import cloudimg from "../Assets/cloud-computing.png"
import iotrobimg from "../Assets/iot-robotics.png"
import cadimg from "../Assets/mechanical-design.png"
import civilengimg from "../Assets/civil-engineering.png"
import pharaceuticalimg from "../Assets/pharmaceutical-research.png"
import biotechimg from "../Assets/biotechnology.png"

const ApplyCourses = () => {
  const [activeFilter, setActiveFilter] = useState('All Programs');
  const [searchTerm, setSearchTerm] = useState('');

  const filters = [
    'All Programs', 'Development', 'AI & Data Science',
    'Design', 'Business', 'Engineering', 'Emerging Tech'
  ];

  // ==================== GET USER DATA FROM LOCAL STORAGE ====================
  const getUserData = () => {
    try {
      // Try multiple localStorage keys
      const userFromAuth = localStorage.getItem('user');
      const userFromCurrent = localStorage.getItem('current_user');
      const userFromData = localStorage.getItem('user_data');
      const token = localStorage.getItem('accessToken') || localStorage.getItem('access_token');

      let name = '';
      let email = '';

      if (userFromAuth) {
        const parsed = JSON.parse(userFromAuth);
        name = parsed.name || parsed.fullName || '';
        email = parsed.email || '';
      } else if (userFromCurrent) {
        const parsed = JSON.parse(userFromCurrent);
        name = parsed.name || parsed.fullName || '';
        email = parsed.email || '';
      } else if (userFromData) {
        const parsed = JSON.parse(userFromData);
        if (Array.isArray(parsed) && parsed.length > 0) {
          name = parsed[0]?.fullName || '';
          email = parsed[0]?.email || '';
        } else {
          name = parsed.fullName || parsed.name || '';
          email = parsed.email || '';
        }
      }

      // JWT fallback
      if (!email && token) {
        try {
          const base64Url = token.split('.')[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
          const payload = JSON.parse(jsonPayload);
          email = payload.email || '';
          name = name || payload.name || payload.sub || '';
        } catch (e) {
          console.error('JWT decode error:', e);
        }
      }

      return { name, email };
    } catch (e) {
      console.error('Error getting user data:', e);
      return { name: '', email: '' };
    }
  };

  // ==================== GOOGLE FORM PRE-FILL FUNCTION WITH EXACT COURSE NAMES ====================
  const applyForCourse = (courseName) => {
    const { name, email } = getUserData();

    // Base Google Form URL
    const formBaseUrl =
      "https://docs.google.com/forms/d/e/1FAIpQLScJf7ut_Co27UykdJMgxpXjT41BmN9LlByagK1QigYslZAkOQ/viewform?usp=pp_url";

    // Build prefilled URL with query parameters
    const params = new URLSearchParams();

    // ✅ Pre-fill Name
    if (name) params.append('entry.479301265', name);

    // ✅ Pre-fill Email
    if (email) params.append('entry.1556369182', email);

    // ✅ Pre-fill Course Name - EXACT MATCHING (spelling and case sensitive)
    // Google Form dropdown options ki exact ga match avvataniki mapping
    let exactCourseName = courseName;
    
    // Optional: If Google Form lo different names unte, mapping create cheyyi
    // Example:
    // const courseMapping = {
    //   "Frontend Development": "Front-End Development",
    //   "Backend Development": "Back-End Development",
    //   "UI/UX Design": "UI/UX Designing"
    // };
    // exactCourseName = courseMapping[courseName] || courseName;
    
    if (exactCourseName) params.append('entry.1542804816', exactCourseName);

    const formUrl = `${formBaseUrl}&${params.toString()}`;
    
    // Debugging: Console lo choodu correct course name vastundo ledo
    console.log('Applying for course:', exactCourseName);
    console.log('Prefilled URL:', formUrl);

    // Open Google Form in new tab
    window.open(formUrl, '_blank');
  };

  // Course data with images - EXACT NAMES (Google Form dropdown options tho match avvali)
  const courseData = [
    { title: "Frontend Development", category: "Development", applicants: "15.2K", duration: "4 Weeks", image: frontendimg },
    { title: "Backend Development", category: "Development", applicants: "12.8K", duration: "4 Weeks", image: backendimg },
    { title: "Full Stack Development", category: "Development", applicants: "83.0K", duration: "4 Weeks", image: fullstackimg },
    { title: "App Development", category: "Development", applicants: "41.5K", duration: "4 Weeks", image: appdevimg },
    { title: "Python Programming", category: "Development", applicants: "10.5K", duration: "4 Weeks", image: pythonimg },
    { title: "Java Programming", category: "Development", applicants: "48.2K", duration: "4 Weeks", image: javaimg },
    { title: "C++ Programming", category: "Development", applicants: "9.2K", duration: "4 Weeks", image: cplusimg },
    { title: "C Programming", category: "Development", applicants: "8.5K", duration: "4 Weeks", image: cimage },
    { title: "DevOps", category: "Development", applicants: "5.3K", duration: "4 Weeks", image: devopsimg },
    { title: "AI Engineering", category: "AI & Data Science", applicants: "22.1K", duration: "4 Weeks", image: aiengimg },
    { title: "Machine Learning", category: "AI & Data Science", applicants: "18.4K", duration: "4 Weeks", image: machineimg },
    { title: "Data Science & AI", category: "AI & Data Science", applicants: "14.6K", duration: "4 Weeks", image: datasceinceimg },
    { title: "Business Analytics", category: "AI & Data Science", applicants: "11.2K", duration: "4 Weeks", image: dataanalyticsimage },
    { title: "Bioinformatics", category: "Emerging Tech", applicants: "2.1K", duration: "4 Weeks", image: bioinfoimg },
    { title: "Power BI", category: "AI & Data Science", applicants: "8.7K", duration: "4 Weeks", image: powerbiimg },
    { title: "Graphic Design", category: "Design", applicants: "19.5K", duration: "4 Weeks", image: graphicdesimg },
    { title: "UI/UX Design", category: "Design", applicants: "15.8K", duration: "4 Weeks", image: uxuiimg },
    { title: "WordPress / CMS Development", category: "Design", applicants: "9.1K", duration: "4 Weeks", image: wordpressimg },
    { title: "Digital Marketing", category: "Business", applicants: "16.3K", duration: "4 Weeks", image: digimarketimg },
    { title: "Content Writing", category: "Business", applicants: "11.2K", duration: "4 Weeks", image: contentwriterimg },
    { title: "Human Resources", category: "Business", applicants: "7.8K", duration: "4 Weeks", image: humanresourceinmg },
    { title: "Stock Market & Trading", category: "Business", applicants: "12.4K", duration: "4 Weeks", image: stockimage },
    { title: "Finance & Investment", category: "Business", applicants: "9.3K", duration: "4 Weeks", image: finaceInvimg },
    { title: "Cybersecurity", category: "Engineering", applicants: "19.2K", duration: "4 Weeks", image: cyberimg },
    { title: "Cloud Computing", category: "Engineering", applicants: "14.5K", duration: "4 Weeks", image: cloudimg },
    { title: "IoT & Robotics", category: "Engineering", applicants: "6.4K", duration: "4 Weeks", image: iotrobimg },
    { title: "CAD / Mechanical Design", category: "Engineering", applicants: "5.9K", duration: "4 Weeks", image: cadimg },
    { title: "Mechanical Design & Simulation", category: "Engineering", applicants: "4.8K", duration: "4 Weeks", image: civilengimg },
    { title: "Civil Engineering", category: "Engineering", applicants: "6.1K", duration: "4 Weeks", image: cimage },
    { title: "Pharmaceutical Research", category: "Emerging Tech", applicants: "3.5K", duration: "4 Weeks", image: pharaceuticalimg },
    { title: "Biotechnology", category: "Emerging Tech", applicants: "4.2K", duration: "4 Weeks", image: biotechimg }
  ];

  // Filter logic
  const filteredCourses = courseData.filter(course => {
    const matchesCategory = activeFilter === 'All Programs' || course.category === activeFilter;
    const matchesSearch = course.title.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-white font-sans selection:bg-sky-100">

      {/* SECTION 1: HERO & SEARCH */}
      <section className="pt-32 pb-16 px-5 flex flex-col items-center text-center">
        <h1 className="text-5xl md:text-6xl font-serif text-slate-900 mb-6">
          Available <span className="text-sky-500 italic">Internships</span>
        </h1>
        <p className="text-slate-500 font-medium max-w-2xl mx-auto leading-relaxed mb-12">
          Choose from a wide range of technical and non-technical domains. Gain hands-on experience and get certified.
        </p>

        {/* Search Bar */}
        <div className="relative w-full max-w-4xl group mb-10">
          <div className="absolute inset-0 bg-sky-400/10 blur-3xl rounded-full opacity-0 group-focus-within:opacity-100 transition-opacity"></div>
          <div className="relative flex items-center bg-white border border-slate-100 shadow-[0_15px_40px_rgba(0,0,0,0.04)] rounded-[24px] px-8 py-5">
            <Search className="text-slate-400 mr-4" size={24} />
            <input
              type="text"
              placeholder="Search domains..."
              className="w-full outline-none text-lg text-slate-700 font-medium placeholder:text-slate-400"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Filter Chips */}
        <div className="flex flex-wrap justify-center gap-3 max-w-5xl mx-auto">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setActiveFilter(f)}
              className={`px-6 py-3 rounded-full text-sm font-bold transition-all ${
                activeFilter === f
                  ? 'bg-[#0f172a] text-white shadow-lg'
                  : 'bg-white border border-slate-100 text-slate-500 hover:bg-slate-50'
              }`}
            >
              {f}
            </button>
          ))}
        </div>
      </section>

      {/* SECTION 2: COURSES GRID */}
      <section className="pb-32 px-5">
        <div className="max-w-[1200px] mx-auto">
          {filteredCourses.length === 0 ? (
            // No results message
            <div className="text-center py-20">
              <div className="text-6xl mb-4">🔍</div>
              <h3 className="text-2xl font-serif text-slate-800 mb-2">No programs found</h3>
              <p className="text-slate-500">Try adjusting your search or filter criteria</p>
            </div>
          ) : (
            // Courses grid
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredCourses.map((course, index) => (
                <div key={index} className="bg-white rounded-[32px] border border-slate-100 shadow-sm hover:shadow-xl transition-all group overflow-hidden flex flex-col">

                  {/* Header Image */}
                  <div className="relative h-56 bg-slate-50 overflow-hidden">
                    <div className="absolute top-4 left-4 z-10">
                      <span className="bg-white/90 backdrop-blur-md text-sky-600 text-[10px] font-black px-3 py-1.5 rounded-lg shadow-sm border border-sky-100 uppercase tracking-wider">
                        {course.category}
                      </span>
                    </div>
                    <div className="w-full h-full flex items-center justify-center p-6">
                      <img
                        src={course.image}
                        alt={course.title}
                        className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  </div>

                  {/* Card Content */}
                  <div className="p-8 flex-1 flex flex-col">
                    <h3 className="text-2xl font-serif text-slate-800 mb-6 group-hover:text-sky-600 transition-colors">
                      {course.title}
                    </h3>

                    {/* Meta Info */}
                    <div className="flex items-center gap-6 mb-10">
                      <div className="flex items-center gap-2 text-sky-500 font-bold text-sm">
                        <Users size={18} strokeWidth={2.5} />
                        <span>{course.applicants}</span>
                      </div>
                      <div className="flex items-center gap-2 text-sky-500 font-bold text-sm">
                        <Clock size={18} strokeWidth={2.5} />
                        <span>{course.duration}</span>
                      </div>
                    </div>

                    {/* ✅ Apply Button — Automatically prefills clicked course name */}
                    <button
                      onClick={() => applyForCourse(course.title)}
                      className="w-full bg-[#0f172a] hover:bg-black text-white py-4 rounded-2xl font-black flex items-center justify-center gap-3 transition-all shadow-lg active:scale-95 mt-auto"
                    >
                      Apply Now
                      <MoveRight size={18} strokeWidth={3} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

    </div>
  );
};

export default ApplyCourses;